export default {
  title: 'Koop e-cadeaubonnen',
  subtitle:
    'Zeg het met een cadeaubon van {{companyName}}. Perfect voor verjaardagen, een bedankje, of gewoon omdat het kan – flexibel inwisselbaar voor eten & drinken.',
  header: {
    title: 'Cadeaubon',
    subtitle: 'Geef vreugde',
  },
  buttons: {
    buy_now: 'Nu kopen',
  },
};
